import React from 'react';

import '@/components/badges/BadgeStyles.css';
import { LTTooltip } from '@/components/ui/LTTooltip';

type StateType = 'ghost' | 'delegated' | 'committed' | 'sealed' | 'inferred';

const STYLE: Record<StateType, string> = {
  ghost: 'lt-badge--blueprint',
  inferred: 'lt-badge--blueprint',
  delegated: 'lt-badge--delegated',
  committed: 'lt-badge--committed',
  sealed: 'lt-badge--sealed',
};

const LABEL: Record<StateType, string> = {
  ghost: 'Ghost',
  inferred: 'Ghost',
  delegated: 'Delegated',
  committed: 'Committed',
  sealed: 'Sealed',
};

const ICON: Record<StateType, string> = {
  ghost: '👻',
  inferred: '👻',
  delegated: '🌑',
  committed: '💎',
  sealed: '✨',
};

const TOOLTIP: Record<StateType, string> = {
  ghost:
    '👻 Ghost (Inferred): AI-generated suggestions that have not yet been claimed by a human; rendered in Blueprint style.',
  inferred:
    '👻 Ghost (Inferred): AI-generated suggestions that have not yet been claimed by a human; rendered in Blueprint style.',
  delegated:
    '🌑 Delegated (Waiting): The torch has been passed, but the sub-owner has not yet materialized their sub-structure.',
  committed:
    '💎 Committed (Solid): The plan is locked, tasks are generated, and the work is officially “Truth”.',
  sealed:
    '✨ Sealed (Platinum): The work is 100% verified and finished; the branch is now an Immutable Achievement.',
};

export function StateBadge({ state }: { state: StateType }) {
  const s = (state || 'inferred') as StateType;
  const icon = ICON[s] || '🏷️';
  const tooltip = TOOLTIP[s] || LABEL[s] || s;
  return (
    <LTTooltip content={tooltip}>
      <span className={`lt-badge ${STYLE[s]}`} tabIndex={0}>
        <span className="lt-badge__icon" aria-hidden>
          {icon}
        </span>
        <span>{LABEL[s] || s}</span>
      </span>
    </LTTooltip>
  );
}

